import React from "react";
import "./LoanAgainst.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const title = "Gold Loan - Get A Loan Against Jewellery";
const pageTitle = "Loan Against Jewelry | Quick & Secure Gold Loans in Nigeria";
const metaDescription =
  "Need a fast loan? Get a quick cash loan against your jewellery in Nigeria. No need to sell, pledge your gold and get funds today. Fast approval and easy repayment!";

const LoanAgainstJewellery = () => {
  return (
    <section className="loan-against-container">
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={metaDescription} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Loan Against Jewelry",
            "provider": {
              "@type": "Organization",
              "name": "Respected Solution"
            },
            "areaServed": "NG"
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Loan Against Jewelry",
            "url": "https://www.respectedsolution.co/loan-against-jewelry"
          })}
        </script>
      </Helmet>

      <div
        className="loan-against-hero-slide"
        style={{ backgroundImage: `url(/assets/images/slider/slider-1.jpeg)` }}
      >
        <div className="loan-against-hero-overlay">
          <div className="loan-against-hero-content">
            <h1>{title}</h1>
          </div>
        </div>
      </div>

      <div className="loan-against-inner">
        <div className="loan-against-inner-content">
          <section className="loan-intro">
            <p>
              Why should you sell your gold jewellery for extremely low prices
              because you are short on cash? When you can just use your gold
              jewellery to get loans from us, why should you keep running from
              one place to another for personal or company loans?
            </p>
            <p>
              Respected Solution allows you to get a gold loan by mortgaging
              your gold jewellery and you can get quick money loans.
            </p>
          </section>

          <section className="loan-against-jewellery-eligibility">
            <h2>What You Need to Do to Get a Loan against Jewellery</h2>
            <p>
              Simply bring in your gold jewellery for assessment and approval.
              To qualify for a loan against Jewellery, you will need to meet the
              following minimum criteria:
            </p>
            <ul>
              <li>
                Provide a valid form of identification (international passport,
                voter card, or driver's license).
              </li>
              <li>Have a valid bank account.</li>
              <li>You must be at least 18 years old.</li>
            </ul>
            <p>
              Our gold loans can be used for various personal and corporate
              purposes, including covering tuition fees, financing your company,
              paying medical bills, and meeting other personal needs.
            </p>
          </section>

          <section className="loan-against-jewellery-benefits">
            <h2>Benefits of Our Gold Loans</h2>
            <ul>
              <li>
                Quick access to funds for emergencies or last-minute financial
                needs.
              </li>
              <li>
                No need for a thorough credit check, as loans are collateralized
                with gold jewelry.
              </li>
              <li>
                Flexible repayment options, including lump sum payments or
                monthly installments.
              </li>
              <li>
                Competitive interest rates compared to other financing options.
              </li>
              <li>
                Borrowers retain ownership of their possessions; the pledged
                gold is returned upon full loan repayment.
              </li>
            </ul>
          </section>

          <section className="loan-against-jewellery-usage">
            <h2>What can you borrow our Gold Loan for?</h2>
            <p>
              You may utilize our gold loan to serve the following personal or
              business requirements, among others:
            </p>
            <ul>
              <li>To settle your children's school fees</li>
              <li>To fund your company</li>
              <li>To cover your medical expenses</li>
              <li>To take care of nearly all personal requirements, etc.</li>
            </ul>
            <p>
              A gold loan provides a practical solution for addressing
              unforeseen expenses or seizing new opportunities. If you require
              funds, consider applying for a gold loan from Respected Solution.
              Find out how much your gold jewelry is worth and start your path
              to financial security right now.
            </p>
          </section>

          <p>
            Are you under financial difficulties and require a loan against
            jewellery and need quick money loans? If so, please do not hesitate
            to <Link to="/contact-us">contact us.</Link>
          </p>
        </div>
      </div>
    </section>
  );
};

export default LoanAgainstJewellery;
